export const GET_OD_REQUEST = "@@ddw.herdnet.sandbox.hnadvice/GET_OD_REQUEST";
export const GET_OD_SUCCESS = "@@ddw.herdnet.sandbox.hnadvice/GET_OD_SUCCESS";
export const GET_OD_FAILURE = "@@ddw.herdnet.sandbox.hnadvice/GET_OD_FAILURE";
